<app-title-component [data]="{name : 'Bureau : '+currentSite().name, back : true, path : 'bureaux'}"></app-title-component>

<mat-card appearance="outlined" class="main-table-card border-0 shadow-sm mt-5">
  @if (loading) {
    <div class="loading-table-shade">
      <mat-spinner diameter="70" color="primary"></mat-spinner>
    </div>
  }
  <mat-card-content class="position-relative p-0 bg-white table-mat-card-content">
      @if (loading) {
        <div class="table-loading-overlay d-flex align-items-center justify-content-center">
          <mat-spinner diameter="48"></mat-spinner>
        </div>
      }

    <mat-tab-group id="tabGroup" #tabGroup (selectedTabChange)="onTabChange($event)"  mat-stretch-tabs="false" mat-align-tabs="start">
      <!---->
      <mat-tab label="Collaborateurs" #collab *ngIf="authUser.getCurrentUser().user.profil['site_collabs']">
        @if (showTabs().collab && (authUser.getCurrentUser().user.profil['site_collabs'])) {
        <div class="d-flex align-items-center justify-content-end p-3 border-bottom">
          <app-search-bar-component (searchBarValue)="applyFilter($event)" appearance="outline"></app-search-bar-component>
        </div>

        <div class="table-container">
         <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" matSort class="w-100 custom-premium-table">
             <!-- -->
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> ID </th>
          <td mat-cell *matCellDef="let row"  data-label=""> {{row.collaborateur_id}} </td>
        </ng-container>
        <!--
        <ng-container matColumnDef="code">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Code </th>
          <td mat-cell *matCellDef="let row"  data-label=""> {{row.code}} </td>
        </ng-container>
        -->

        <!-- -->
        <ng-container matColumnDef="logo">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Logo </th>
          <td mat-cell *matCellDef="let row"  data-label="">
              <div class="logo-container">
                <img class="avatar-img" [src]="API_STORAGE + row.logo" alt="logo" (error)="$event.target.style.display='none'">
              </div>
          </td>
        </ng-container>

        <!-- -->
        <ng-container matColumnDef="collaborateur">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Collaborateurs </th>
          <td mat-cell *matCellDef="let row"  data-label=""> {{row.collaborateur_name | uppercase }} </td>
        </ng-container>

        <!-- -->
        <ng-container matColumnDef="owner">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Proprietaire </th>
          <td mat-cell *matCellDef="let row"  data-label=""> {{row.owner | uppercase }} </td>
        </ng-container>

        <!-- -->
        <ng-container matColumnDef="adresse">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Adresse </th>
          <td mat-cell *matCellDef="let row"  data-label=""> {{row.adresse | uppercase }} </td>
        </ng-container>

        <!-- Action -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef sticky="true" class="table-row-actions"> Actions </th>
           <td mat-cell *matCellDef="let row" class="table-row-actions">
            <mat-slide-toggle labelPosition='after' [checked]="row.active" (change)="changeCollabState(row)">
              @if (row.active) { <span class="text-green">Associe</span> }
              @else { <span class="text-red"> Non Associe </span> }
            </mat-slide-toggle>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        <!-- Row shown when there is no matching data. -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="4">No data matching the filter "</td>
        </tr>
                </table>
      </div>        </div>
        }
      </mat-tab>
      <!---->

      <!---->
      <mat-tab label="Utilisateurs" #user *ngIf="authUser.getCurrentUser().user.profil['site_users']">
        @if (showTabs().user) {
        <div class="d-flex align-items-center justify-content-end p-3 border-bottom">
          <app-search-bar-component (searchBarValue)="applyFilter($event)" class="me-1 mt-4" appearance="outline"></app-search-bar-component>
            <button matTooltip="Nouveau site" (click)="openAddUserModal()" mat-flat-button color="primary" class="btn-add px-4 py-4 fw-semibold">
                <mat-icon>add</mat-icon>
                <span>Ajouter</span>
            </button>
        </div>
            <!---->
          <div class="table-container">
           <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" matSort class="w-100 custom-premium-table">
              <!-- -->
              <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> ID </th>
                <td mat-cell *matCellDef="let row"  data-label=""> {{row.id}} </td>
              </ng-container>

              <!-- -->
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Nom & Prenom </th>
                <td mat-cell *matCellDef="let row" class="fw-semibold text-dark" data-label=""> {{row.name | uppercase }} </td>
              </ng-container>


              <!-- -->
              <ng-container matColumnDef="profil">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Profil </th>
                <td mat-cell *matCellDef="let row"  data-label=""> {{row.profil_name | uppercase }} </td>
              </ng-container>

              <!-- -->
              <ng-container matColumnDef="gender">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Genre </th>
                <td mat-cell *matCellDef="let row"  data-label=""> {{row.gender | uppercase }} </td>
              </ng-container>

              <!-- -->
              <ng-container matColumnDef="adresse">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Adresse </th>
                <td mat-cell *matCellDef="let row"  data-label=""> {{row.adresse | uppercase }} </td>
              </ng-container>

              <!-- -->
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Etat </th>
                <td mat-cell *matCellDef="let row"  data-label="">
                  @if(row.disable){
                    <span class="badge-status status-inactive">Désactivé</span>
                  } @else {
                    <span class="badge-status status-active">Actif</span>
                  }
                </td>
              </ng-container>

              <!-- Action -->
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef sticky="true" class="table-row-actions"> Actions </th>
                <td mat-cell *matCellDef="let row" class="table-row-actions">
                  <button (click)="onChange(row)" [matTooltip]="row.disable?'Debloquer':'Bloquer'" matButton="" color="primary" type="button">
                    @if (row.disable) {<mat-icon style="color: rgb(0, 95, 0);">frame_person</mat-icon>}
                    @else {<mat-icon style="color: rgb(194, 126, 0);">frame_person_off</mat-icon>}

                  </button>
                  <button matTooltip="modifier" (click)="openUpdateUserModal(row)" matButton="" color="primary" type="button">
                    <mat-icon class="text-muted-icon">edit</mat-icon>
                  </button>
                  <button matTooltip="supprimer" (click)="confirm(row)" matButton="" color="warn" type="button">
                     <mat-icon>delete_outline</mat-icon>
                  </button>
                </td>
              </ng-container>


              <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

              <!-- Row shown when there is no matching data. -->
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">No data matching the filter "{{searchValue}}"</td>
              </tr>
                  </table>
      </div>          </div>
        }
      </mat-tab>

    </mat-tab-group>
  </mat-card-content>
  <mat-card-footer>
      <mat-paginator [pageSizeOptions]="[6, 10, 25, 100]" aria-label="Select page of users"></mat-paginator>
  </mat-card-footer>
</mat-card>
